<div class="m-portlet  m-portlet--full-height">
    <div class="m-portlet__body">

      <div class="user-profile">
        <h2>
          {{userInfo?.name}}
          <small *ngIf="!userInfo?.active">탈퇴</small>
          <small *ngIf="userInfo?.admin" class="m--font-danger">어드민</small>
        </h2>
        <div center-v>
          <span class="gender" [style.color]="userInfo?.UserProfile?.gender == 'M' ? '#83b1d7' : '#df8d8d'">
            {{userInfo?.UserProfile?.gender == 'M' ? '남자' : '여자'}}
          </span>
          <p class="birthday">
            {{userInfo?.UserProfile?.hm_unsure ? '시간 모름' : '시간 설정'}}
          </p>
        </div>
      </div>

      <div class="user-info">
        <div>
          <h5>이메일</h5>
          <p>{{userInfo?.email}}</p>
        </div>
        <div>
          <h5>가입일자</h5>
          <p>{{userInfo?.created_at | date:'yyyy. MM. dd.':'+0900'}}</p>
        </div>
        <div class="devices">
          <h5>사용 기기</h5>
          <div>
            <a *ngFor="let device of userInfo?.Devices"
               class="device-item"
              href="/cs/user-search?type=device&keyword={{device.id}}"
               target="_blank"
            >
              {{device.id}} | {{device.name}} | {{device.os}} {{device.version}} | v{{device.appVersion + ' ' + (device.updated_at | date:'yyyy. MM. dd. HH:mm:ss':'+0900')}}
            </a>
          </div>
        </div>
      </div>

      <hr/>

      <div class="user-function">
        <div center-v>
          <h5>프로필 수정 시간</h5>
          <p>{{(userInfo?.UserProfile?.modified_at | date:'yyyy. MM. dd. HH:mm:ss':'+0900') || '수정 이력 없음'}}</p>
          <button *ngIf='userInfo?.UserProfile?.modified_at' class="btn-reset btn-outline-primary" type="submit" (click)="resetProfileTime()">7일 전으로</button>
        </div>
        <div center-v>
          <h5>국가 변경 가능 여부</h5>
          <input type="checkbox" class="m-checkbox" [ngModel]="userInfo?.enable_transfer" (ngModelChange)="changeCountry($event)" />
        </div>
        <div center-v class="cursor-pointer" (click)="changeAdmin()">
          <i [ngClass]="{'m--font-success': userInfo?.admin}" class="fa fa-cog"></i>
          <span class="ml-1">어드민 설정</span>
        </div>
        <div center-v class="cursor-pointer" (click)="openFas('sazoo')">
          <i class="m-nav__link-icon fa fa-address-card" style="font-size:13px"></i>
          <span class="ml-1">FAS</span>
        </div>
        <div center-v class="cursor-pointer" (click)="openFas('astro')">
          <i class="m-nav__link-icon fa fa-address-card" style="font-size:13px"></i>
          <span class="ml-1">ASTRO FAS</span>
        </div>
        <div center-v class="cursor-pointer" (click)="resetOnborarding()">
          <i class="m-nav__link-icon fa fa-address-card" style="font-size:13px"></i>
          <span class="ml-1">온보딩 초기화</span>
        </div>
        <div *ngIf="lang === 'ko'" center-v class="cursor-pointer" (click)="openWelcomeQuestModal()">
          <i class="m-nav__link-icon fa fa-refresh" style="font-size:13px"></i>
          <span class="ml-1">웰컴퀘스트 초기화</span>
        </div>
      </div>
    </div>
</div>

<ng-template #welcomeQuestModal>
  <div class="modal-header">
    <h4 class="modal-title">웰컴퀘스트 초기화</h4>
    <button type="button" class="close" aria-label="Close" [disabled]="welcomeQuestPending" (click)="closeWelcomeQuestModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body welcome-quest-modal">
    <p *ngIf="welcomeQuestLoading" class="text-muted mb-0">불러오는 중...</p>

    <ng-container *ngIf="!welcomeQuestLoading">
      <div class="field">
        <h5>대상 유저</h5>
        <p class="mb-0">{{userInfo?.name}} <span class="text-muted">(#{{userInfo?.id}})</span></p>
      </div>

      <div class="field">
        <h5>현재 배정</h5>
        <div class="info-card">
          <ng-container *ngIf="welcomeQuestStatus; else noAssignment">
            <div class="info-row">
              <span class="info-label">버전</span>
              <span>
                <span class="m-badge m-badge--primary m-badge--wide">v{{welcomeQuestStatus.version}}</span>
                <span class="m-badge m-badge--wide ml-2"
                      [ngClass]="isWelcomeQuestPeriodEnded() ? 'm-badge--metal' : 'm-badge--success'">
                  {{isWelcomeQuestPeriodEnded() ? '기간 종료' : '진행 중'}}
                </span>
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">대상 기간</span>
              <span>{{welcomeQuestPeriodLabel()}}</span>
            </div>
          </ng-container>
          <ng-template #noAssignment>
            <span class="text-muted">배정 이력이 없습니다.</span>
          </ng-template>
        </div>
      </div>

      <div class="field">
        <h5>재배정할 버전</h5>
        <select class="form-control" [(ngModel)]="selectedWelcomeQuestVersion">
          <option *ngFor="let version of welcomeQuestVersions" [ngValue]="version.version">
            {{welcomeQuestVersionLabel(version)}}
          </option>
        </select>
      </div>

      <div class="m-alert m-alert--outline alert alert-warning mb-0" role="alert">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="ml-1">진행 기록이 모두 삭제되고 선택한 버전으로 다시 시작됩니다.</span>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button *ngIf="welcomeQuestStatus" class="btn btn-outline-danger mr-auto" type="button"
            title="배정과 진행 기록이 모두 삭제됩니다. (초기화는 기록 삭제 후 재배정)"
            [disabled]="welcomeQuestPending" (click)="endWelcomeQuest()">웰컴퀘스트 종료</button>
    <button class="btn btn-secondary" type="button" [disabled]="welcomeQuestPending" (click)="closeWelcomeQuestModal()">취소</button>
    <button class="btn btn-danger" type="button" [disabled]="welcomeQuestPending || welcomeQuestLoading" (click)="resetWelcomeQuest()">초기화</button>
  </div>
</ng-template>
